  const formContainer = document.querySelector(".l-form");
  const firstForm = document.getElementById("warrantyFirstForm");
  const secondForm = document.getElementById("warrantySecondForm");
  const thankYou = document.querySelector(".thank-you-section");
  const containerdesc = document.querySelector(".l-form-container h3");
  const containerImage = document.querySelector(".l-form-container .warranty-image-container");
  const submitBtn = document.getElementById("btn_submit");
  const purchasedProductsInput = document.getElementById("purchasedProducts");
  const orderDateID = document.getElementById("orderDate");
  const uploadFileInput = document.getElementById("uploadFile");

  orderDateID.max = new Date().toISOString().split("T")[0];

  const showError = (input, message) => {
    const parent = input.parentNode;
    const errorMessage = parent.querySelector('.error_message') ?? document.createElement("div");
    errorMessage.textContent = message;
    errorMessage.classList.add('error_message');
    input.insertAdjacentElement('afterend', errorMessage);
  };
  
  const hideError = (input) => {
    const parent = input.parentNode;
    parent.querySelector('.error_message')?.remove();
  };
  
  const validateForm = (form) => {
    let isValid = true;
  
    form.querySelectorAll("input").forEach(input => {
      hideError(input);
      const isInvalid = !input.validity.valid;

      if (isInvalid) {
        isValid = false;
        showError(input, input.type === 'email' ? '*Invalid email.': '*Please fill out this field.');
      } 
    });
  
    return isValid;
  };
  
  const nextForm = (e) => {
    e.preventDefault();
    if (validateForm(firstForm)) {
      firstForm.classList.remove("active-section");
      secondForm.classList.add("active-section");
      const btnSubmit = document.getElementById("btn_submit");
      btnSubmit.style.display = 'block';
      e.target.style.display = 'none';
    }
  };
  
  const onInput = (e) => {
    e.preventDefault();
    const input = e.target;
    const isInvalid = !input.validity.valid;
  
    if (isInvalid) {
      hideError(input);
      showError(input, input.type === 'email' ? '*Invalid email.' : input.type === 'tel' ? '*This field should contain numbers only.' : '*Please fill out this field.');
    } else {
      hideError(input);
    }
  };
  
  const onFocusOut = (e) => {
    e.preventDefault();
    const input = e.target;
    if (!input.validity.valid) {
      showError(input, '*Please fill out this field.');
    }
  };

  const selectedProductsDiv = document.getElementById("selectedProducts");
  
  let productTitles;

  const fetchProductTitles = async () => {
    try {
      if (!productTitles) {
        const response = await fetch("https://cdn.shopify.com/s/files/1/0609/2898/3299/files/products.json", {
          method: "GET",
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const res = await response.json();
        productTitles = res.names;
  
        // Filtered in front end as from my research, there was no way to filter in the backend with "-title: extended warranty*" in the query
        typeAhead(
          purchasedProductsInput,
          productTitles.filter((item) => !/extended warranty/i.test(item))
        );
      }
    } catch (error) {
      console.error("Error fetching and processing data:", error);
    }
  };
  const typeAhead = (input, list) => {
    let timeoutId;
    let suggestionsContainer;
    
    const showSuggestions = () => {
      clearTimeout(timeoutId);
      const inputValue = input.value.toLowerCase();
      
      // Clear the previous suggestions
      if (suggestionsContainer) {
        suggestionsContainer.remove();
      }
      
      if (inputValue.length >= 1) {
        timeoutId = setTimeout(() => {
          const filteredList = list.filter((product) => product.toLowerCase().includes(inputValue));
          
          const filteredListWithoutSelected = filteredList.filter((item) => {
            return ![...selectedProductsDiv.children].some((child) => child.querySelector("span").textContent.trim() === item);
          });
          
          // Display the new suggestions
          suggestionsContainer = document.createElement("div");
          suggestionsContainer.classList.add("suggestions-container");
          
          filteredListWithoutSelected.forEach((product) => {
            const suggestion = document.createElement("div");
            suggestion.textContent = product;
            suggestion.classList.add("suggestion");
            
            suggestion.addEventListener("click", function () {
              input.value = '';
              addSelectedProduct(product);
              suggestionsContainer.remove();
            });
            
            suggestionsContainer.appendChild(suggestion);
          });
          
          input.parentNode.appendChild(suggestionsContainer);
        }, 200);
      } else {
        // If the input is empty, clear the suggestions
        if (suggestionsContainer) {
          suggestionsContainer.remove();
        }
      }
    };

    let isSuggestionsVisible = false; 
    const beforeContentElement = document.querySelector(".arrow-dropdown");

    const onClickShowSuggestions = () => {
      clearTimeout(timeoutId);

      if (isSuggestionsVisible) {
       
        if (suggestionsContainer) {
          suggestionsContainer.remove();
        }
        isSuggestionsVisible = false; 
      } else {
        suggestionsContainer = document.createElement("div");
        suggestionsContainer.classList.add("suggestions-container");

        list.forEach((product) => {
          const suggestion = document.createElement("div");
          suggestion.textContent = product;
          suggestion.classList.add("suggestion");

          suggestion.addEventListener("click", function () {
            beforeContentElement.style.transform = 'rotate(360deg)';
            input.value = '';
            addSelectedProduct(product);
            suggestionsContainer.remove();
            isSuggestionsVisible = false; 
          });

          suggestionsContainer.appendChild(suggestion);
        });

        input.parentNode.appendChild(suggestionsContainer);
        isSuggestionsVisible = true; 
      }
    };
  
    
    if (beforeContentElement) {
      onClickShowSuggestions();
    
      beforeContentElement.addEventListener("click", () => {
          onClickShowSuggestions();
          if(isSuggestionsVisible) {
            beforeContentElement.style.transform = 'rotate(180deg)'
          } else {
            beforeContentElement.style.transform = 'rotate(360deg)'
          }
      });

      if(isSuggestionsVisible) {
        beforeContentElement.style.transform = 'rotate(180deg)'
      } else {
        beforeContentElement.style.transform = 'rotate(360deg)'
      }
   
    }
  
    input.addEventListener("input", showSuggestions);
  };
  
  function addSelectedProduct(product) {
    const hiddenInput = document.createElement("input");
    hiddenInput.setAttribute("type", "hidden");
    hiddenInput.setAttribute("name", "selectedProducts");
    hiddenInput.setAttribute("value", product);
  
    const selectedProductDiv = document.createElement("div");
    selectedProductDiv.classList.add("product-item"); // Add a class to style the product item if needed
  
    const productTitleSpan = document.createElement("span");
    productTitleSpan.textContent = product;
    selectedProductDiv.appendChild(productTitleSpan);
  
    const deleteIcon = document.createElement("span");
    deleteIcon.innerHTML = "&#10005;"; // Add your custom delete icon as needed
    deleteIcon.classList.add("delete-icon"); // Add a class to style the delete icon if needed
    selectedProductDiv.appendChild(deleteIcon);
  
    selectedProductsDiv.appendChild(selectedProductDiv);
  
    // Add onclick event to the deleteIcon
    deleteIcon.onclick = function () {
      selectedProductsDiv.removeChild(selectedProductDiv);
      // If needed, you can also remove the corresponding hiddenInput
      document.querySelector("div").removeChild(hiddenInput);
    };
    
    hideError(purchasedProductsInput);
  }

  function handleDelete(event) {
    const clickedElement = event.target;
    selectedProductsDiv.removeChild(clickedElement);
  }
  


  document.getElementById("amazonForm").addEventListener("submit", function (event) {
    event.preventDefault();
    const selectedProductsChildren = selectedProductsDiv.children;
    let purchasedProducts = "";

    for (let i = 0; i < selectedProductsChildren.length; i++) {
    const child = selectedProductsChildren[i];
    const productTitle = child.querySelector("span").textContent.trim();
    purchasedProducts += productTitle;
    if (i !== selectedProductsChildren.length - 1) {
        purchasedProducts += ", "; // Add a comma and space between items
    }
    }
    if(purchasedProducts == '') {
        showError(purchasedProductsInput, '*Please select product');
        return
    }

    const file = document.getElementById("uploadFile").files[0];
    
    if (file) {
      // Check if the file size is greater than 5MB (5 * 1024 * 1024 bytes)
      if (file.size > 5 * 1024 * 1024) {
          showError(uploadFileInput, '*File size exceeds 5MB limit.');
          return;
      }
    }
        
        submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.classList.add('loading');
        submitBtn.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
        const orderId = document.getElementById("orderId").value;
        const orderDate = document.getElementById("orderDate").value;
        // const purchasedProducts = document.getElementById("purchasedProducts").value;
        const firstName = document.getElementById("firstName").value;
        const lastName = document.getElementById("lastName").value;
        const email = document.getElementById("email").value;
        const phoneNumber = document.getElementById("phoneNumber").value;
        const declinesMarketing = document.getElementById("acceptsMarketing").checked;

      if (file) {
          // Convert file to base64
          const reader = new FileReader();
          // Read the contents of the file and send it to the server
          reader.onloadend = function () {
              sendData(orderId, orderDate, purchasedProducts, firstName, lastName, email, phoneNumber, declinesMarketing, file, reader);
          };
          reader.readAsDataURL(file);
      } else {
          // If no file is selected, send data without file
          sendData(orderId, orderDate, purchasedProducts, firstName, lastName, email, phoneNumber, declinesMarketing, null, null);
      }
  
  function sendData(orderId, orderDate, purchasedProducts, firstName, lastName, email, phoneNumber, declinesMarketing, file, reader) {
      fetch("https://modlighting-func.netlify.app/.netlify/functions/amazon-form", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify({
              orderDetails: {
                  id: orderId,
                  date: orderDate,
                  purchasedProducts,
                  firstName,
                  lastName,
                  email,
                  phoneNumber,
                  declinesMarketing
              },
              file: file
                  ? {
                      base64: reader.result.split(",")[1],
                      name: file.name,
                      type: file.type,
                      size: file.size,
                  }
                  : null,
          }),
      })
        .then((response) => {
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }
          if (response.headers.get('content-type') && response.headers.get('content-type').includes('application/json')) {
            return response.json();
          } else {
              throw new Error('Response is not JSON');
          }
        })
          .then((data) => {
              thankYou.classList.add('active-section');
              formContainer.style.display = 'none';
              containerdesc.style.display = 'none';
              containerImage.style.display = 'none';
          })
          .catch((error) => {
            console.log(error);
          });
  }
});